import React from 'react';

interface AdminFieldLabelProps {
  htmlFor: string;
  label: string;
  required?: boolean;
  languageSwitcher?: React.ReactNode;
}

const AdminFieldLabel: React.FC<AdminFieldLabelProps> = ({
                                                           htmlFor,
                                                           label,
                                                           required = false,
                                                           languageSwitcher
                                                         }) => {
  return (
    <div className="flex justify-between items-center mb-2">
      <label htmlFor={htmlFor} className={`block text-sm text-gray-700 ${required ? 'font-semibold' : 'font-medium'}`}>
        {label}{required && <span className="text-gray-700 ml-1 relative -top-1.5">٭</span>}
      </label>
      {languageSwitcher && (
        <div className="ml-auto">
          {languageSwitcher}
        </div>
      )}
    </div>
  );
};

export default AdminFieldLabel;

